import { render, staticRenderFns } from "./OneTimeNoRideList.vue?vue&type=template&id=06509957&scoped=true"
import script from "./OneTimeNoRideList.vue?vue&type=script&lang=js"
export * from "./OneTimeNoRideList.vue?vue&type=script&lang=js"
import style0 from "./OneTimeNoRideList.vue?vue&type=style&index=0&id=06509957&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06509957",
  null
  
)

export default component.exports